'use client';

import React from 'react';
import { LangProvider } from './LanguageContext';
import NavBar from './NavBar';
import HeroSection from './HeroSection';
import MarqueeBar from './MarqueeBar';
import DestinationsSection from './DestinationsSection';
import UzbekistanSection from './UzbekistanSection';
import WhyUsSection from './WhyUsSection';
import ContactSection from './ContactSection';
import FooterSection from './FooterSection';

export default function HomepageInteractive() {
  return (
    <LangProvider>
      <div className="noise" aria-hidden="true" />
      <NavBar />
      <main>
        <HeroSection />
        <MarqueeBar />
        <DestinationsSection />
        <UzbekistanSection />
        <WhyUsSection />
        <ContactSection />
      </main>
      <FooterSection />
    </LangProvider>
  );
}